import { render, staticRenderFns } from "./Beleza.vue?vue&type=template&id=45a62523&scoped=true"
import script from "./Beleza.vue?vue&type=script&lang=js"
export * from "./Beleza.vue?vue&type=script&lang=js"
import style0 from "./Beleza.vue?vue&type=style&index=0&id=45a62523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a62523",
  null
  
)

export default component.exports